// Pages the console serves WITHOUT a session.
//
// /login, /signup, /signup/confirm and /downloads are reached by visitors who
// have no JWT by design (self-service signup, VM-image downloads, passkey or
// password login). Session recovery must therefore never touch them: a 401 from
// a public endpoint there is a normal answer, not an expired session, and the
// wake-up watcher has nothing to probe. Both the fetch layer's hard redirect and
// the session watcher gate on this helper.
const PUBLIC_PATHS = ['/login', '/signup', '/signup/confirm', '/downloads']

export function isPublicPath(pathname: string = window.location.pathname): boolean {
    // Tolerate a trailing slash ('/signup/' === '/signup').
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
    return PUBLIC_PATHS.includes(path)
}
